module.exports = __webpack_public_path__ + "img/material.1ec73c52.svg";